// extracted by mini-css-extract-plugin
export default {"root":"ExpertsMenuPage_root__WBzPD","header":"ExpertsMenuPage_header__G9C79","body":"ExpertsMenuPage_body__7NKCY"};